/**
 * PowerAvailabilityRerunPanel — thin wrapper around FeasibilityRerunPanel
 * with power-domain gap categorization (Grid capacity / Interconnection
 * queue / Rate data / BTM tech / Renewables). Workflow Prompt 6.
 */
import React from 'react';
import { FeasibilityRerunPanel, type RerunPanelProps, type DataGapItem } from './FeasibilityRerunPanel';
import { getGapCategoriesForType } from '../../../lib/rerunGapCategories';

export function PowerAvailabilityRerunPanel(props: RerunPanelProps) {
  return (
    <FeasibilityRerunPanel
      {...props}
      gapCategorizer={(gaps: DataGapItem[]) => getGapCategoriesForType('power-availability', gaps)}
    />
  );
}
